<ng-container
  *ngIf="{
    tactics: tactics$ | async,
    cyborgMitreFilter: cyborgMitreFilter$ | async
  } as data"
>
  <div
    class="loading"
    *ngIf="!(data.tactics && data.cyborgMitreFilter); else mitreDashboard"
  >
    <kendo-loader type="pulsing" themeColor="primary" size="large">
    </kendo-loader>
  </div>

  <ng-template #mitreDashboard>
    <section class="example-section">
      <kendo-label text="Staged Hunt Packages ">
        <kendo-switch
          [disabled]="deployedChecked"
          class="example-margin"
          (valueChange)="toggleStagedDeploys()"
          [(ngModel)]="stagedChecked"
        ></kendo-switch>
      </kendo-label>
      <kendo-label text="Deployed Hunt Packages ">
        <kendo-switch
          [disabled]="stagedChecked"
          class="example-margin"
          (valueChange)="toggleDeployedDeploys()"
          [(ngModel)]="deployedChecked"
        ></kendo-switch>
      </kendo-label>
    </section>
    <mitre-section>
      <table>
        <thead>
          <tr>
            <th *ngFor="let column of headers">
              <mat-card class="mat-elevation-z10">
                <mat-card-title title="{{ column | titlecase }}">
                  <div>{{ column | titlecase }}</div>
                </mat-card-title>
              </mat-card>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let i of rows$ | async">
            <td *ngFor="let tactic of data.tactics">
              <mitre-card
                *ngIf="tactic.children[i]"
                [cyborgMitreFilter]="data.cyborgMitreFilter"
                [companyDeployedMitreFilter]="deployedDeploys$ | async"
                [companyStagedMitreFilter]="stagedDeploys$ | async"
                [tactic]="tactic"
                [child]="tactic.children[i]"
              ></mitre-card>
            </td>
          </tr>
        </tbody>
      </table>
    </mitre-section>
  </ng-template>
</ng-container>
